// apiservice.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//?�험�??�급 리스??
export const fetchSevList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/sev`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};
//(?�인)?�용???�보?�정
export const editUserInfo = async (token, userInfo) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/user`,
      userInfo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response;
  } catch (error) {
 console.error("editUserInfo error:", error);
    throw error;  // ?�러�??�출??쪽으�??�짐
  }         
};
//가�??�보 ?�정
export const editFamilyInfo = async (token, familyInfo) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/fam`,
      familyInfo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response;
  } catch (error) {
 console.error("editUserInfo error:", error);
    throw error;  // ?�러�??�출??쪽으�??�짐
  }         
};
//가족�?계리?�트
export const getRelation = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/rel`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};
//(?�인)?�용????��
export const deleteUser = async (userId, token) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/user/${userId}`,
      {
        headers: { Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
          Accept: "application/json", },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
//?�용???�성
export const registerUserWithFamily = async (sendData, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/user`,
      sendData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("가�??�보 ?�록 ?�패:", error);
    throw error;
  }
};

//?�급?�황 api
export const getEmergencyLogs = async (userId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/feed/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    console.log("?�급?�황 ?�답 ?�체:", response);
    return response.data.feedback || [];
  } catch (error) {  
    console.error("?�급?�황 기록 API ?�류:", error);  
    throw error; 
  }
};

//?�급?�황 ?�정 api
export const updateEmergencyLog = async ({ alert_id, content, admin_id, token }) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/feed`,
      {alert_id, content, admin_id,},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("?�급?�황 ?�정 ?�답:", response);
    return response.data;
  } catch (error) {
    console.error("?�급?�황 ?�정 ?�패:", error);
    throw error;
  }
};


// ?�급?�황 ??�� API
export const deleteEmergencyLog = async (alert_id, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/feed/${alert_id}`, {
      headers: {
         Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    console.log("?�급?�황 ??�� ?�답:", response);
    return response.data;
  } catch (error) {
    console.error("?�급?�황 ??�� ?�패:", error);
    throw error;
  }
};


/* ?�력 */
export const getPowerTimeline = async (userId, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/power/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('?�� API ?�답 ?�이??', response.data);
    // power ?�로?�티 배열 리턴
    return response.data.power || [];
  } catch (error) {
    console.error("???�력???�이??가?�오�??�패", error);
    return [];
  }
};

/* ?�위�?*/
export const getSwitchInfo = async (userId,token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/switch/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};

// userApiServicer.js
export const submitEmergencyLog = async ({ token, user_id, content, admin_id }) => {
  try {
    // ???�제�?보내???�이???�인
    console.log("?�� ?�급?�황 ?�록 ?�청:", {
      url: `${API_BASE_URL}/dashboard-alert/log`,
      body: { user_id, content, admin_id },
      token,
    });

    const response = await axios.post(
      `${API_BASE_URL}/dashboard-alert/log`,
      { user_id, content, admin_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // ???�버 ?�답 ?�인
    console.log("?�� ?�급?�황 ?�록 ?�답:", response.data);

    return response.data;
  } catch (error) {
    console.error("???�급처리 ?�???�패:", error.response?.data || error.message);
    return { success: false, message: error.response?.data?.message || '?�록 ?�패' };
  }
};
